// extracted by mini-css-extract-plugin
export default {"smallMin":"320px","smallMax":"767px","mediumMin":"767.001px","mediumMax":"1135px","largeMin":"1135.001px","largeMax":"1391px","xlargeMin":"1391.001px"};